<template>
  <div class="main background-gradient">
    <div class="containerBlock">
      
      <div class="methodsDeposit">
        <div class="tabs-wrapper">
          <div class="tabs-inner">
            <span 
              v-for="tab in tabList" 
              :key="tab"
              :class="['tab-item', { active: currentTab === tab }]"
              @click="selectTab(tab)"
            >{{ tab }}</span>
          </div>
        </div>
        
        <ul class="eWalletList">
          <li 
            v-for="method in filteredPaymentMethods" 
            :key="method.id"
            :class="['wallet-item', { active: selectedPaymentMethod && selectedPaymentMethod.id === method.id }]"
            @click="selectPaymentMethod(method)"
          >
            <div v-if="method.bonus" class="bonus-ribbon">
              <span>{{ method.bonus }}</span>
            </div>
            <div class="method-content">
              <div class="img-box">
                <img :src="method.img" alt="">
              </div>
              <span class="method-name">{{ method.name }}</span>
            </div>
            <div v-if="selectedPaymentMethod && selectedPaymentMethod.id === method.id" class="check-mark"></div>
          </li>
        </ul>
      </div>

      <div class="depositAmountSet">
        <div class="amount-header">
          <span class="title">{{ $t('Deposit Amount') }}</span>
        </div>
        
        <div class="amount-input-wrapper">
          <span class="currency">¥</span>
          <input 
            type="number" 
            v-model="depositAmount" 
            @input="amount = depositAmount === '' ? null : Number(depositAmount)"
            class="amount-input"
            placeholder="0.00"
            :min="selectedPaymentMethod ? selectedPaymentMethod.min_price : 0"
            :max="selectedPaymentMethod ? selectedPaymentMethod.max_price : 999999"
          >
          <div v-if="selectedPaymentMethod && selectedPaymentMethod.remark" class="payment-remark">
            <span>{{ selectedPaymentMethod.remark }}</span>
          </div>
        </div>
        
        <div class="quick-amount-grid">
          <span @click="selectAmount(100)" :class="['quick-btn', { active: depositAmount == 100 }]">100</span>
          <span @click="selectAmount(200)" :class="['quick-btn', { active: depositAmount == 200 }]">200</span>
          <span @click="selectAmount(500)" :class="['quick-btn', { active: depositAmount == 500 }]">500</span>
          <span @click="selectAmount(1000)" :class="['quick-btn', { active: depositAmount == 1000 }]">1,000</span>
          <span @click="selectAmount(2000)" :class="['quick-btn', { active: depositAmount == 2000 }]">2,000</span>
          <span @click="selectAmount(5000)" :class="['quick-btn', { active: depositAmount == 5000 }]">5,000</span>
          <span @click="selectAmount(10000)" :class="['quick-btn', { active: depositAmount == 10000 }]">{{ $t('10K') }}</span>
          <span @click="selectAmount(30000)" :class="['quick-btn', { active: depositAmount == 30000 }]">{{ $t('30K') }}</span>
          <span @click="selectAmount(50000)" :class="['quick-btn', { active: depositAmount == 50000 }]">{{ $t('50K') }}</span>
          <span @click="selectAmount(100000)" :class="['quick-btn', { active: depositAmount == 100000 }]">{{ $t('100K') }}</span>
        </div>
      </div>
      
      <div v-if="paymentInfoVisible || pendingRecharge" class="payment-info-panel">
        <div class="payment-info-title">收款信息</div>
        <div class="payment-info-content">
          <img
            v-if="selectedPaymentMethod && selectedPaymentMethod.receiptImage"
            :src="selectedPaymentMethod.receiptImage"
            class="payment-info-image"
            alt=""
          >
          <div class="payment-info-name">
            {{ selectedPaymentMethod ? selectedPaymentMethod.receiptTitle : '' }}
          </div>
          <div v-if="selectedPaymentMethod && selectedPaymentMethod.receiptDescription" class="payment-info-remark">
            {{ selectedPaymentMethod.receiptDescription }}
          </div>
          <div class="payment-info-amount">充值金额：¥{{ pendingRecharge ? pendingRecharge.amount : amount }}</div>
        </div>
      </div>

      <div v-if="paymentInfoVisible || pendingRecharge" class="proof-upload-panel">
        <div class="proof-upload-title">
          {{ $t('Upload Recharge Receipt') }}
          <span class="proof-required">{{ $t('Required') }}</span>
        </div>
        <div class="proof-upload-order">
          <span v-if="pendingRecharge">{{ $t('Order No.') }}：{{ pendingRecharge.out_trade_no }}</span>
          <span v-else>{{ selectedPaymentMethod ? selectedPaymentMethod.name : '' }}</span>
          <span>¥{{ pendingRecharge ? pendingRecharge.amount : amount }}</span>
        </div>
        <div class="proof-upload-tip">请核对上方收款信息，上传付款凭证后提交</div>
        <input
          ref="proofInput"
          type="file"
          accept="image/jpeg,image/png,image/gif,image/webp"
          class="proof-file-input"
          @change="selectProofFile"
        >
        <button type="button" class="proof-select-btn" @click="$refs.proofInput.click()">
          {{ proofFile ? $t('Change Receipt Image') : $t('Choose Receipt Image') }}
        </button>
        <img v-if="proofPreview" :src="proofPreview" class="proof-preview" alt="">
        <div v-if="proofFile" class="proof-file-name">{{ proofFile.name }}</div>
        <button
          type="button"
          :class="['proof-submit-btn', { disabled: !proofFile || uploadingProof }]"
          @click="uploadProof"
        >
          {{ uploadingProof ? $t('Uploading') : $t('Submit Receipt') }}
        </button>
      </div>

      <div v-if="!paymentInfoVisible && !pendingRecharge" class="submit-action">
        <button
          :disabled="!canSubmit || uploadingProof"
          :class="['btn-submit', { disabled: !canSubmit || uploadingProof }]"
          @click="confirmDeposit"
        >
          <span class="btn-text">{{ $t('Confirm Deposit') }}</span>
          <span class="btn-light"></span>
        </button>
        <div class="submit-hint">确认金额后先查看收款信息，再上传凭证提交</div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: '',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      meyXi: 'TRC20',
      payWayList: {},
      payTypeList: [],
      payMethods: {},
      currentPayMethods: [],
      selectedMethod: null,
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
      currentTab: '',
      tabList: [],
      allPaymentMethods: [],
      selectedPaymentMethod: null,
      depositAmount: '',
      pendingRecharge: null,
      paymentInfoVisible: false,
      proofFile: null,
      proofPreview: '',
      uploadingProof: false,
    };
  },
  created() {
    let that = this;
    sessionStorage.removeItem('pendingRecharge');
    that.getPayWay();
    that.getBanklist();
    that.getPaymentMethodsFromBackend();
  },
  activated() {
    this.resetRechargePage();
  },
  methods: {
    resetRechargePage() {
      if (this.proofPreview) URL.revokeObjectURL(this.proofPreview);
      sessionStorage.removeItem('pendingRecharge');
      this.amount = null;
      this.depositAmount = '';
      this.pendingRecharge = null;
      this.paymentInfoVisible = false;
      this.proofFile = null;
      this.proofPreview = '';
      this.uploadingProof = false;

      if (this.tabList.length > 0) {
        this.currentTab = this.tabList[0];
        const firstMethod = this.allPaymentMethods.find(method => method.tabName === this.currentTab);
        if (firstMethod) this.selectPaymentMethod(firstMethod);
      }

      this.$nextTick(() => {
        if (this.$refs.proofInput) this.$refs.proofInput.value = '';
      });
    },
    selectTab(tab) {
      if (!this.pendingRecharge) this.resetProofDraft();
      this.currentTab = tab;
      this.$nextTick(() => {
        const method = this.filteredPaymentMethods[0];
        if (method) this.selectPaymentMethod(method);
      });
    },
    getPaymentMethodsFromBackend() {
      let that = this;
      that.showLoading();
      
      that.$apiFun
        .get('/api/getAllPaymentMethods', {})
        .then(res => {
          if (res.code == 200 && res.data) {
            const tabNames = [];
            that.allPaymentMethods = res.data.map((item, index) => {
              let bonus = '';
              if (item.bonus_ratio) {
                const bonusValue = Math.floor(parseFloat(item.bonus_ratio));
                bonus = `${that.$t('Bonus_Text')}${bonusValue}%`;
              }

              const displayName = String(item.name || '').trim() || that.$t('Payment Method');
              if (tabNames.indexOf(displayName) === -1) tabNames.push(displayName);
              
              return {
                id: item.id,
                type: item.type,
                name: displayName,
                tabName: displayName,
                category: item.category,
                img: item.img || '',
                amount: `${item.min_price}-${item.max_price}`,
                bonus: bonus,
                isFee: false,
                min_price: item.min_price,
                max_price: item.max_price,
                data: item.data,
                bonus_ratio: item.bonus_ratio,
                exchange_rate: item.exchange_rate,
                wallet_address: item.wallet_address,
                pay_qrcode: item.pay_qrcode,
                remark: item.data ? item.data.remark : '',
                receiptTitle: item.receipt_title || displayName,
                receiptDescription: item.receipt_description || (item.data ? item.data.remark : ''),
                receiptImage: item.receipt_image || '',
              };
            });

            that.tabList = tabNames;
            if (that.tabList.indexOf(that.currentTab) === -1) {
              that.currentTab = that.tabList[0] || '';
            }
            
            const firstMethod = that.filteredPaymentMethods[0];
            if (firstMethod) {
              that.selectPaymentMethod(firstMethod);
            } else {
              that.selectedPaymentMethod = null;
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getPayRange() {
      let that = this;
      let type = null;

      if (that.pay_way == 'bank') type = 'bank';
      if (that.pay_way == 'wechat') type = 'wechat';
      if (that.pay_way == 'alipay') type = 'alipay';
      if (that.pay_way == 'usdt') {
        if (that.meyXi == 'ERC20') type = 'usdt-erc20';
        if (that.meyXi == 'TRC20') type = 'usdt-trc20';
      }
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changShow() { this.show = !this.show; },
    onConfirm(value, index) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() { this.show = false; },
    changXiyi(val) {
      if (this.meyXi == val) return;
      this.meyXi = val;
      this.getPayRange();
    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200 && res.data) {
            that.payWayList = res.data;
            const typeMap = {
              'card': { type: 'bank', name: 'Online Banking Transfer' },
              'usdt': { type: 'usdt', name: 'USDT' },
              'wechat': { type: 'wechat', name: 'WeChat' },
              'alipay': { type: 'alipay', name: 'Alipay' }
            };
            
            that.payTypeList = [];
            for (let key in res.data) {
              if (res.data[key] == 1 && typeMap[key]) {
                that.payTypeList.push({
                  type: typeMap[key].type,
                  name: that.$t(typeMap[key].name),
                  icon: that.getDefaultIcon(typeMap[key].type)
                });
              }
            }
            
            if (that.payTypeList.length > 0) {
              that.pay_way = that.payTypeList[0].type;
              that.getPayMethods(that.pay_way);
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getPayMethods(type) {
      let that = this;
      that.showLoading();
      
      if (type === 'bank') {
        that.$apiFun
          .post('/api/getpaybank', {})
          .then(res => {
            if (res.code == 200 && res.data) {
              that.currentPayMethods = res.data.map((item, index) => ({
                id: item.id || index,
                name: item.bank_data ? item.bank_data.bank_name : that.$t('Bank Card'),
                icon: that.getDefaultIcon('bank'),
                description: item.bank_owner,
                bank_info: {
                  account_no: item.bank_no,
                  account_name: item.bank_owner,
                  bank_name: item.bank_data ? item.bank_data.bank_name : '',
                  bank_address: item.bank_address
                }
              }));
              if (that.currentPayMethods.length > 0) {
                that.selectedMethod = that.currentPayMethods[0];
              }
            }
            that.getPayRange();
            that.hideLoading();
          })
          .catch(res => {
            that.hideLoading();
          });
      } else {
        that.currentPayMethods = [{
          id: 1,
          name: type === 'usdt' ? 'USDT' : type === 'wechat' ? that.$t('WeChat') : that.$t('Alipay'),
          icon: that.getDefaultIcon(type),
          description: ''
        }];
        that.selectedMethod = that.currentPayMethods[0];
        that.getPayRange();
        that.hideLoading();
      }
    },
    selectMethod(method) {
      this.selectedMethod = method;
    },
    getDefaultIcon(type) {
      const iconMap = {
        'bank': '/static/image/icoOnlineTransfer2@3x.png',
        'card': '/static/image/icoOnlineTransfer2@3x.png',
        'usdt': '/static/image/1595237922936176.png',
        'wechat': '/static/image/QuickWechat.png',
        'wxpay': '/static/image/QuickWechat.png',
        'alipay': '/static/image/icoAlipay2@3x.png',
      };
      return iconMap[type] || '/static/image/icoOnlineTransfer2@3x.png';
    },
    payTest() {
      let that = this;
      let info = {};

      if (!that.selectedMethod) {
        that.showTost(0, that.$t('Please select a payment method'));
        return;
      }

      if (that.pay_way == 'bank') {
        info = {
          paytype: that.pay_way,
          method_id: that.selectedMethod.id,
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        if (!info.bank_owner) { that.showTost(0, that.$t("Please enter the depositor's name")); return; }
        if (!info.bank) { that.showTost(0, that.$t('Please enter the bank type')); return; }
        if (!info.bank_no) { that.showTost(0, that.$t('Please enter the bank card number')); return; }
        if (!info.bank_address) { that.showTost(0, that.$t('Please enter the bank account opening address')); return; }
      } else {
        info = {
          paytype: that.pay_way,
          method_id: that.selectedMethod.id,
          amount: that.amount * 1,
        };
      }
      if (that.pay_way == 'usdt') {
        info.catepay = that.meyXi;
      }

      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.showTost(0, `${that.$t('Please enter an amount between ')}${that.min_price}${that.$t(' and ')}${that.max_price}${that.$t('!')}`);
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;

      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (that.pay_way == 'bank') {
              that.showTost(1, that.$t('Submitted successfully, waiting for background review'));
              that.bankBox = {};
              that.amount = null;
              that.hideLoading();
              that.$router.push({ path: '/transRecord' });
              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.$router.push({ path: `/payInfo?deposit_no=${res.message}` });
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) return;
      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      that.selectedMethod = null;
      that.getPayMethods(val);
    },
    goNav(url) {
      this.$parent.goNav(url);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.showTost(1, this.$t('Copied successfully!'));
    },
    getUserInfo() {
      this.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    selectPaymentMethod(method) {
      if (this.selectedPaymentMethod && this.selectedPaymentMethod.id !== method.id && !this.pendingRecharge) {
        this.resetProofDraft();
      }
      this.selectedPaymentMethod = method;
      if (method.min_price) this.min_price = method.min_price;
      if (method.max_price) this.max_price = method.max_price;
      this.selectedMethod = method;
      
      this.pay_way = method.data && method.data.category === 'alipay' ? 'alipay' : 'wechat';
    },
    confirmDeposit() {
      if (this.uploadingProof) return;
      if (this.pendingRecharge) {
        this.showTost(0, this.$t('Please submit the receipt for the current order first'));
        return;
      }
      if (!this.selectedPaymentMethod) {
        this.showTost(0, this.$t('Please select a payment method'));
        return;
      }
      if (!this.canSubmit) return;
      const rawAmount = this.depositAmount !== '' && this.depositAmount !== null
        ? this.depositAmount
        : this.amount;
      this.amount = Number(rawAmount);
      this.paymentInfoVisible = true;
      this.$nextTick(() => {
        const panel = this.$el.querySelector('.payment-info-panel');
        if (panel && panel.scrollIntoView) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    },
    selectProofFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        this.showTost(0, this.$t('Please select an image'));
        event.target.value = '';
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.showTost(0, this.$t('Receipt image cannot exceed 10MB'));
        event.target.value = '';
        return;
      }
      this.proofFile = file;
      this.proofPreview = URL.createObjectURL(file);
    },
    uploadProof() {
      if ((!this.pendingRecharge && !this.paymentInfoVisible) || !this.proofFile || this.uploadingProof) return;
      const formData = new FormData();
      if (this.pendingRecharge) {
        formData.append('recharge_id', this.pendingRecharge.id);
      } else {
        formData.append('payment_method_id', this.selectedPaymentMethod.id);
        formData.append('amount', Number(this.amount));
      }
      formData.append('proof', this.proofFile);
      this.uploadingProof = true;
      this.$apiFun.post(this.pendingRecharge ? '/api/recharge/receipt' : '/api/recharge/manual/submit', formData).then(res => {
        if (res.code !== 200) {
          this.showTost(0, res.message);
          return;
        }
        this.showTost(1, this.$t('Receipt uploaded, waiting for review'));
        this.clearProof();
        this.$router.push({ path: '/transRecord' });
      }).catch(() => {
        this.showTost(0, this.$t('Network error, please try again'));
      }).finally(() => {
        this.uploadingProof = false;
      });
    },
    clearProof() {
      if (this.proofPreview) URL.revokeObjectURL(this.proofPreview);
      this.pendingRecharge = null;
      this.paymentInfoVisible = false;
      sessionStorage.removeItem('pendingRecharge');
      this.proofFile = null;
      this.proofPreview = '';
      if (this.$refs.proofInput) this.$refs.proofInput.value = '';
    },
    resetProofDraft() {
      if (this.proofPreview) URL.revokeObjectURL(this.proofPreview);
      this.paymentInfoVisible = false;
      this.proofFile = null;
      this.proofPreview = '';
      if (this.$refs.proofInput) this.$refs.proofInput.value = '';
    },
    selectAmount(val) {
      if (this.paymentInfoVisible && !this.pendingRecharge) this.resetProofDraft();
      this.amount = val;
      this.depositAmount = val;
    },
  },
  computed: {
    filteredPaymentMethods() {
      if (!this.currentTab) return this.allPaymentMethods;
      return this.allPaymentMethods.filter(method => method.tabName === this.currentTab);
    },
    canSubmit() {
      const rawAmount = this.depositAmount !== '' && this.depositAmount !== null
        ? this.depositAmount
        : this.amount;
      const amount = Number(rawAmount);
      const minPrice = Number(this.selectedPaymentMethod ? this.selectedPaymentMethod.min_price : this.min_price);
      const maxPrice = Number(this.selectedPaymentMethod ? this.selectedPaymentMethod.max_price : this.max_price);
      return !this.pendingRecharge
        && !!this.selectedPaymentMethod
        && Number.isFinite(amount)
        && amount > 0
        && amount >= minPrice
        && amount <= maxPrice;
    }
  },
};
</script>

<style lang="scss" scoped>
/* 1. 沉浸式暗黑耀金全局背景 */
.background-gradient {
  background: radial-gradient(circle at top right, #2a2a2a, #0a0a0a) !important;
  min-height: 100vh;
  color: #e0e0e0;
}

.main {
  width: 100%;
  padding: 70px 15px 30px 15px; /* 适配顶部导航栏 */
  box-sizing: border-box;
}

.containerBlock {
  background: transparent;
  box-sizing: border-box;
}

/* 2. 标签栏 (高质感深灰胶囊 + 流光金选中) */
.tabs-wrapper {
  margin-bottom: 25px;
  
  .tabs-inner {
    display: flex;
    background: #1c1c1e; /* 极深灰 */
    border-radius: 40px;
    padding: 6px;
    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.05);
    
    .tab-item {
      flex: 1;
      text-align: center;
      padding: 10px 0;
      border-radius: 30px;
      font-size: 14px;
      color: #888888;
      cursor: pointer;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      font-weight: 500;
      position: relative;
      
      &.active {
        background: linear-gradient(135deg, #ffe082, #d1a03e); /* 高级香槟金 */
        color: #5c3a00; /* 极深的金色字体 */
        font-weight: bold;
        box-shadow: 0 4px 15px rgba(209, 160, 62, 0.4);
      }
    }
  }
}

/* 3. 支付通道列表 (拟物浮雕卡片) */
.methodsDeposit {
  margin-bottom: 25px;
  
  .eWalletList {
    display: flex;
    flex-wrap: wrap;
    gap: 12px; /* 更优雅的网格间距 */
    
    .wallet-item {
      width: calc(33.33% - 8px); /* 一行三个 */
      height: 100px;
      background: linear-gradient(145deg, #2a2a2c, #1f1f21); /* 微弱的质感渐变 */
      border-radius: 14px;
      border: 1px solid rgba(255, 255, 255, 0.06);
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-shadow: 4px 4px 10px rgba(0,0,0,0.4), -2px -2px 8px rgba(255,255,255,0.02); /* 新拟态浮雕 */
        
      &.active {
        background: #1a1a1a;
        border-color: #d1a03e; /* 金色边框 */
        box-shadow: 0 0 0 1px #d1a03e, 0 6px 15px rgba(209, 160, 62, 0.25); /* 耀金光晕 */
      }
        
      .bonus-ribbon {
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(135deg, #ff4d4d, #c60000);
        color: #fff;
        padding: 3px 8px;
        font-size: 11px;
        font-weight: bold;
        z-index: 10;
        border-radius: 0 0 10px 0;
        box-shadow: 2px 2px 6px rgba(0,0,0,0.3);
      }
      
      .method-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .img-box {
          height: 38px;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          
          img {
            max-width: 50px;
            max-height: 100%;
            object-fit: contain;
            filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3)); /* 图标立体感 */
          }
        }
        
        .method-name {
          font-size: 13px;
          font-weight: 500;
          color: #cccccc; /* 柔和白 */
          text-align: center;
        }
      }

      /* 右下角选中对勾 */
      .check-mark {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 0;
        height: 0;
        border-bottom: 24px solid #d1a03e;
        border-left: 24px solid transparent;
        
        &::after {
          content: '✓';
          position: absolute;
          right: 2px;
          bottom: -22px;
          color: #fff;
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }
}

/* 4. 存款金额输入与快捷按钮 (高定面板) */
.depositAmountSet {
  margin-bottom: 30px;
  background: linear-gradient(180deg, #242426 0%, #1a1a1c 100%);
  border-radius: 20px;
  padding: 24px 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.6);
  
  .amount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 0.5px;
    }
    
  }
  
  /* 沉浸式无边框金额输入 */
  .amount-input-wrapper {
    position: relative;
    margin-bottom: 25px;
    display: flex;
    align-items: flex-end;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 8px;
    transition: border-color 0.3s;

    &:focus-within {
      border-bottom-color: #d1a03e; /* 聚焦时底部亮起金线 */
    }
    
    .currency {
      font-size: 26px;
      color: #d1a03e; 
      font-weight: bold;
      margin-right: 10px;
      padding-bottom: 2px;
    }
    
    .amount-input {
      flex: 1;
      border: none;
      background: transparent;
      color: #ffffff; 
      font-size: 36px; /* 超大醒目字体 */
      font-weight: bold;
      outline: none;
      width: 100%;
      caret-color: #d1a03e; /* 光标也变成金色 */
      
      &::placeholder {
        color: rgba(255, 255, 255, 0.2);
        font-size: 18px;
        font-weight: normal;
        transform: translateY(-5px);
      }
      
      /* 隐藏自带恶心箭头 */
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    
    .payment-remark {
      position: absolute;
      right: 0;
      top: 5px;
      color: #888;
      font-size: 12px;
    }
  }
  
  /* 快捷金额芯片式按钮 */
  .quick-amount-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 4列更显宽敞 */
    gap: 12px;
    
    .quick-btn {
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 8px;
      padding: 12px 0;
      font-size: 15px;
      font-weight: 500;
      color: #bbbbbb;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
      
      &.active {
        background: rgba(209, 160, 62, 0.12); /* 内部透出暗金光 */
        border: 1px solid #d1a03e; /* 金色边框 */
        color: #fceb99; /* 亮金色文字，不刺眼且高级 */
        font-weight: bold;
        box-shadow: 0 4px 10px rgba(209, 160, 62, 0.2);
      }
    }
  }
}

/* 5. 确认存款按钮 (奢华金脉冲) */
.submit-action {
  margin-bottom: 40px;
  
  .btn-submit {
    position: relative;
    width: 100%;
    height: 54px;
    background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%); /* 渐变拉开层次 */
    color: #4a2e00; /* 极深咖色字 */
    border: none;
    border-radius: 14px;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 2px;
    cursor: pointer;
    overflow: hidden;
    box-shadow: 0 6px 20px rgba(209, 160, 62, 0.4), inset 0 2px 0 rgba(255, 255, 255, 0.4); /* 底部外发光 + 顶部内高光 */
    transition: all 0.3s;
    
    .btn-text {
      position: relative;
      z-index: 2;
      text-shadow: 0 1px 1px rgba(255,255,255,0.4); /* 文字立体感 */
    }
    
    /* 按钮上的流光效果 */
    .btn-light {
      position: absolute;
      top: 0;
      left: -100%;
      width: 50%;
      height: 100%;
      background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
      transform: skewX(-25deg);
      animation: sweep 3s infinite;
      z-index: 1;
    }
    
    &.disabled {
      background: #333333; 
      color: #666666;
      box-shadow: none;
      cursor: not-allowed;
      .btn-light { display: none; }
      .btn-text { text-shadow: none; }
    }
    
    &:active:not(.disabled) {
      transform: translateY(2px);
      box-shadow: 0 2px 10px rgba(209, 160, 62, 0.4);
    }
  }
}

.proof-upload-panel {
  margin: 0 0 40px;
  padding: 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #242426 0%, #1a1a1c 100%);
  border: 1px solid rgba(209, 160, 62, 0.45);
  color: #fff;
}

.payment-info-panel {
  margin: 0 0 18px;
  padding: 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #242426 0%, #1a1a1c 100%);
  border: 1px solid rgba(209, 160, 62, 0.45);
  color: #fff;
  text-align: center;
}

.payment-info-title {
  margin-bottom: 14px;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

.payment-info-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.payment-info-image {
  width: 180px;
  height: 180px;
  padding: 8px;
  border-radius: 8px;
  background: #fff;
  object-fit: contain;
}

.payment-info-name {
  margin-top: 12px;
  color: #fceb99;
  font-size: 15px;
  font-weight: bold;
}

.payment-info-remark {
  margin-top: 6px;
  color: #aaa;
  font-size: 12px;
}

.payment-info-amount {
  margin-top: 10px;
  color: #d1a03e;
  font-size: 14px;
  font-weight: bold;
}

.proof-upload-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.proof-upload-order {
  color: #d1a03e;
  font-size: 12px;
  word-break: break-all;
}

.proof-upload-order span {
  float: right;
}

.proof-required {
  color: #ff8c8c;
  font-size: 12px;
  font-weight: normal;
}

.proof-upload-tip {
  margin: 15px 0 10px;
  color: #aaa;
  font-size: 12px;
}

.proof-file-input {
  display: none;
}

.proof-select-btn,
.proof-submit-btn {
  width: 100%;
  min-height: 42px;
  border-radius: 10px;
  border: 1px solid rgba(209, 160, 62, 0.6);
  background: transparent;
  color: #fceb99;
  font-size: 13px;
}

.proof-submit-btn {
  margin-top: 10px;
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
  color: #4a2e00;
  border: 0;
  font-weight: bold;
}

.proof-select-btn.disabled,
.proof-submit-btn.disabled {
  opacity: 0.45;
  pointer-events: none;
}

.proof-preview {
  display: block;
  width: 100%;
  max-height: 180px;
  margin-top: 12px;
  object-fit: contain;
  border-radius: 8px;
  background: #111;
}

.proof-file-name {
  margin-top: 8px;
  color: #d1a03e;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.submit-hint {
  margin-top: 8px;
  color: #999;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

/* 按钮流光动画 */
@keyframes sweep {
  0% { left: -100%; }
  20% { left: 200%; }
  100% { left: 200%; }
}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue